import { Link } from 'react-router-dom';
import {
  CircleStackIcon,
  CpuChipIcon,
  CreditCardIcon,
  DocumentTextIcon,
  KeyIcon,
  UsersIcon,
  WalletIcon,
  WrenchScrewdriverIcon,
} from '@heroicons/react/24/outline';
import type { ReactNode } from 'react';

interface ConfigLink {
  to: string;
  title: string;
  description: string;
  icon: ReactNode;
}

const configLinks: ConfigLink[] = [
  {
    to: '/admin/users',
    title: 'Kullanıcılar ve roller',
    description: 'Hesap rolleri, erişim ve üyelik yönetimi',
    icon: <UsersIcon />,
  },
  {
    to: '/admin/storage-providers',
    title: 'Depolama sağlayıcıları',
    description: 'S3, MinIO, GCS, Azure ve özel endpointler',
    icon: <CircleStackIcon />,
  },
  {
    to: '/admin/social-providers',
    title: 'Social Login',
    description: 'Google, GitHub, Microsoft ve diğer OAuth kaynakları',
    icon: <KeyIcon />,
  },
  {
    to: '/admin/ai-providers',
    title: 'AI sağlayıcılar',
    description: 'Model API anahtarları, endpoint ve limitler',
    icon: <CpuChipIcon />,
  },
  {
    to: '/admin/ai-prompts',
    title: 'AI promptlar',
    description: 'Sistem promptları ve model eşlemeleri',
    icon: <DocumentTextIcon />,
  },
  {
    to: '/admin/payment-providers',
    title: 'Ödeme sağlayıcıları',
    description: 'Stripe, iyzico ve abonelik planları',
    icon: <CreditCardIcon />,
  },
  {
    to: '/admin/crypto-wallets',
    title: 'Kripto cüzdanları',
    description: 'USDT, USDC ve ağ adresleri',
    icon: <WalletIcon />,
  },
  {
    to: '/admin/disclaimers',
    title: 'Disclaimers',
    description: 'Terms, privacy, cookie ve uyarı metinleri',
    icon: <DocumentTextIcon />,
  },
  {
    to: '/admin/install',
    title: 'Kurulum',
    description: 'Veritabanı migrasyonları, seed ve sistem kurulumu',
    icon: <WrenchScrewdriverIcon />,
  },
];

export function Settings() {
  return (
    <div className="admin-page">
      <header className="admin-page-header">
        <div>
          <h1>Ayarlar</h1>
          <p>
            Global uygulama ayarları için ayrı bir API yok. Yapılandırma ilgili admin
            ekranlarından yönetilir.
          </p>
        </div>
      </header>

      <div className="admin-settings-hub">
        {configLinks.map((item) => (
          <Link key={item.to} to={item.to} className="admin-settings-hub-card">
            <span className="admin-settings-hub-icon" aria-hidden>
              {item.icon}
            </span>
            <span className="admin-settings-hub-text">
              <span className="admin-settings-hub-title">{item.title}</span>
              <span className="admin-settings-hub-desc">{item.description}</span>
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
